/* HeliumDeploy on-site SALES chat — private preview (2026-09-26).
 * Only on the Harlo B30 and Magic Miner 40T pages (each embeds this script itself; it
 * is not injected site-wide by theme.liquid). Invisible to everyone by default: it only
 * shows once this browser has visited with ?hd_sales=<preview key> (see data-key on the
 * script tag). After that one visit it remembers via localStorage, so Abel does not need
 * the link twice. No key, ever = no DOM change, same convention as the hdlab loader.
 * Talks to the sales-chat bridge (SSE): POST data-broker + /sales-chat/session, /chat.
 */
(function () {
  var SCRIPT = document.getElementById('hd-sales-widget') || document.currentScript;
  var BROKER = (SCRIPT && SCRIPT.dataset && SCRIPT.dataset.broker || '').replace(/\/$/, '');
  var KEY = SCRIPT && SCRIPT.dataset && SCRIPT.dataset.key || '';
  if (!BROKER || !KEY) return;

  var LS = 'hd_sales_preview';
  try {
    var url = new URL(location.href);
    var given = url.searchParams.get('hd_sales');
    if (given && given === KEY) localStorage.setItem(LS, '1');
    if (given) { url.searchParams.delete('hd_sales'); history.replaceState({}, '', url); }
  } catch (e) { /* URL/localStorage unavailable — stay invisible */ }
  var unlocked = false;
  try { unlocked = localStorage.getItem(LS) === '1'; } catch (e) { /* no storage, no widget */ }
  if (!unlocked) return; // the whole point: nobody else ever gets past this line

  var LIME = '#d1fb18';
  var css = [
    '#hdsw-launch{position:fixed;left:20px;bottom:20px;z-index:2147483000;width:56px;height:56px;border-radius:999px;',
    'background:' + LIME + ';color:#0a0a0a;border:2px solid #0a0a0a;cursor:pointer;font-size:22px;',
    'box-shadow:0 10px 30px rgba(209,251,24,.35);display:flex;align-items:center;justify-content:center}',
    '#hdsw-launch:after{content:"";position:absolute;top:-3px;right:-3px;width:12px;height:12px;border-radius:999px;background:#f59e0b;border:2px solid #0a0a0a}',
    '#hdsw-panel{position:fixed;left:20px;bottom:86px;z-index:2147483001;width:380px;max-width:calc(100vw - 24px);',
    'height:560px;max-height:calc(100vh - 120px);background:#0a0a0a;color:#f5f5f5;border-radius:16px;overflow:hidden;',
    'display:none;flex-direction:column;box-shadow:0 30px 80px rgba(0,0,0,.6);border:1px solid #262626;',
    "font-family:Inter,-apple-system,sans-serif}",
    '#hdsw-panel.open{display:flex}',
    '#hdsw-head{padding:12px 14px;background:#111;border-bottom:1px solid #262626;display:flex;align-items:center;gap:8px}',
    '#hdsw-head b{font-family:"Space Grotesk",sans-serif;font-size:14px}',
    '#hdsw-head span{font-size:10.5px;color:#f59e0b;background:rgba(245,158,11,.12);border:1px solid rgba(245,158,11,.3);',
    'padding:2px 7px;border-radius:999px;font-weight:700;letter-spacing:.03em}',
    '#hdsw-x{margin-left:auto;background:none;border:none;color:#8a8a8a;font-size:20px;cursor:pointer;padding:2px 6px}',
    '#hdsw-msgs{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:9px}',
    '.hdsw-m{max-width:88%;padding:9px 12px;border-radius:14px;font-size:13.5px;line-height:1.45;white-space:pre-wrap;word-break:break-word}',
    '.hdsw-m.customer{align-self:flex-end;background:' + LIME + ';color:#0a0a0a;border-bottom-right-radius:4px}',
    '.hdsw-m.agent{align-self:flex-start;background:#1c1c1c;border-bottom-left-radius:4px}',
    '#hdsw-form{display:flex;gap:8px;padding:10px;border-top:1px solid #262626;background:#111}',
    '#hdsw-in{flex:1;background:#1c1c1c;border:1px solid #303030;border-radius:10px;color:#fff;padding:9px 11px;font-size:13.5px;font-family:inherit}',
    '#hdsw-send{background:' + LIME + ';color:#0a0a0a;border:none;border-radius:10px;padding:0 14px;font-weight:700;cursor:pointer}',
    '#hdsw-send:disabled{opacity:.5;cursor:default}',
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var launch = document.createElement('button'); launch.id = 'hdsw-launch'; launch.type = 'button'; launch.textContent = '💬';
  launch.title = 'Sales chat preview (only visible to you)';
  var panel = document.createElement('div'); panel.id = 'hdsw-panel';
  panel.innerHTML =
    '<div id="hdsw-head"><b>Sales chat</b><span>PREVIEW · only you see this</span><button id="hdsw-x" type="button">✕</button></div>' +
    '<div id="hdsw-msgs"></div>' +
    '<form id="hdsw-form"><input id="hdsw-in" autocomplete="off" placeholder="Ask about this miner…"><button id="hdsw-send" type="submit">Send</button></form>';
  document.body.appendChild(launch); document.body.appendChild(panel);

  var msgs = panel.querySelector('#hdsw-msgs'), input = panel.querySelector('#hdsw-in'), send = panel.querySelector('#hdsw-send');
  var S = { sid: '', key: '', busy: false };

  function add(role, text) {
    var d = document.createElement('div'); d.className = 'hdsw-m ' + role; d.textContent = text;
    msgs.appendChild(d); msgs.scrollTop = msgs.scrollHeight; return d;
  }

  function post(path, body) {
    return fetch(BROKER + path, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) });
  }

  function ensureSession() {
    if (S.sid) return Promise.resolve();
    return post('/sales-chat/session', { preview_key: KEY }).then(function (r) {
      if (!r.ok) throw new Error('session');
      return r.json();
    }).then(function (j) { S.sid = j.session_id; S.key = j.key; });
  }

  // ctx: page facts for Sarah (never shown to the shopper), sent with this one message.
  function send_(text, ctx) {
    if (!text || S.busy) return;
    S.busy = true; send.disabled = true;
    add('customer', text);
    var live = null;
    ensureSession().then(function () {
      return post('/sales-chat/chat', { session_id: S.sid, key: S.key, text: text, context: ctx || '' });
    }).then(function (r) {
      if (!r.ok || !r.body) throw new Error('chat');
      var reader = r.body.getReader(), dec = new TextDecoder(), buf = '';
      function pump() {
        return reader.read().then(function (res) {
          if (res.done) return;
          buf += dec.decode(res.value, { stream: true });
          var frames = buf.split('\n\n'); buf = frames.pop();
          frames.forEach(function (frame) {
            var line = frame.split('\n').filter(function (l) { return l.indexOf('data:') === 0; })[0];
            if (!line) return;
            var ev; try { ev = JSON.parse(line.slice(5).trim()); } catch (e) { return; }
            if (ev.type === 'text') {
              if (!live) live = add('agent', '');
              live.textContent += ev.text; msgs.scrollTop = msgs.scrollHeight;
            } else if (ev.type === 'error' && !live) {
              add('agent', 'Something went wrong on this preview. Try again?');
            }
          });
          return pump();
        });
      }
      return pump();
    }).catch(function () {
      if (!live) add('agent', 'Preview is offline right now.');
    }).finally(function () { S.busy = false; send.disabled = false; input.focus(); });
  }

  launch.onclick = function () {
    panel.classList.toggle('open');
    if (panel.classList.contains('open') && !msgs.children.length) {
      add('agent', "Hey, this is the sales-chat preview — only you can see it on this page. Ask it anything a shopper might.");
      input.focus();
    }
  };
  // Other pages open the chat already mid-conversation, e.g. the miner estimator:
  //   window.HDSales.open({ message: "Why is the Magic Miner 40T best for me?", context: "…numbers…" })
  // The message shows as the shopper's first line; Sarah answers it with the context in hand.
  window.HDSales = {
    open: function (o) {
      o = o || {};
      panel.classList.add('open');
      if (o.message) send_(String(o.message), String(o.context || '').slice(0, 1500));
      else input.focus();
    }
  };
  try { document.dispatchEvent(new CustomEvent('hdsales:ready')); } catch (e) { /* old browser */ }
  panel.querySelector('#hdsw-x').onclick = function () { panel.classList.remove('open'); };
  panel.querySelector('#hdsw-form').onsubmit = function (e) {
    e.preventDefault();
    var v = input.value.trim(); if (!v) return;
    input.value = ''; send_(v);
  };
})();
